(() => {
  'use strict';

  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const searchSelector = '.rps-csb-container';
  let searchBar = null;
  let originalParent = null;
  let originalNextSibling = null;
  let searchObserver = null;

  function findHeaderIcons() {
    return (
      document.querySelector('sticky-header .header__icons') ||
      document.querySelector('.header-wrapper .header__icons') ||
      document.querySelector('header.header .header__icons') ||
      document.querySelector('.header__icons')
    );
  }

  function rememberSearchPosition(bar) {
    if (searchBar === bar) return;
    searchBar = bar;
    originalParent = bar.parentNode;
    originalNextSibling = bar.nextSibling;
  }

  function restoreSearchPosition() {
    if (!searchBar || !originalParent?.isConnected || searchBar.parentNode === originalParent) return;
    const nextSibling = originalNextSibling?.parentNode === originalParent ? originalNextSibling : null;
    originalParent.insertBefore(searchBar, nextSibling);
  }

  function placeSearchBar() {
    const bar = document.querySelector(searchSelector);
    if (!bar) return false;

    rememberSearchPosition(bar);

    if (!desktopMedia.matches) {
      restoreSearchPosition();
      return true;
    }

    const headerIcons = findHeaderIcons();
    if (!headerIcons) return false;
    if (bar.parentNode !== headerIcons) headerIcons.appendChild(bar);
    return true;
  }

  function initialiseSearchPlacement() {
    if (placeSearchBar()) return;
    searchObserver?.disconnect();
    searchObserver = new MutationObserver(() => {
      if (placeSearchBar()) searchObserver.disconnect();
    });
    searchObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => searchObserver?.disconnect(), 5000);
  }

  function forcePageTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  const paginationFlag = 'ac_collection_pagination_to_top';

  function isPaginationLink(link) {
    if (!link?.href) return false;
    try {
      const target = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);
      return (
        target.origin === current.origin &&
        target.pathname === current.pathname &&
        target.searchParams.has('page') &&
        target.searchParams.get('page') !== current.searchParams.get('page')
      );
    } catch (_error) {
      return false;
    }
  }

  function observeProductGridRefresh() {
    const grid = document.querySelector('#product-grid');
    const target = grid?.parentElement || grid;
    if (!target) return;

    const observer = new MutationObserver(() => {
      forcePageTop();
      observer.disconnect();
    });
    observer.observe(target, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 2000);
  }

  function completePaginationReset() {
    forcePageTop();
    requestAnimationFrame(forcePageTop);
    window.setTimeout(forcePageTop, 100);
    window.setTimeout(forcePageTop, 350);
    sessionStorage.removeItem(paginationFlag);
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!isPaginationLink(link)) return;
      sessionStorage.setItem(paginationFlag, '1');
      observeProductGridRefresh();
      window.setTimeout(forcePageTop, 0);
    },
    true,
  );

  ['pushState', 'replaceState'].forEach((methodName) => {
    const original = history[methodName];
    history[methodName] = function (...args) {
      const before = window.location.href;
      const result = original.apply(this, args);
      const after = window.location.href;
      if (before !== after && new URL(after).searchParams.has('page')) completePaginationReset();
      return result;
    };
  });

  window.addEventListener('popstate', () => {
    if (new URL(window.location.href).searchParams.has('page')) completePaginationReset();
  });

  window.addEventListener('pageshow', () => {
    if (sessionStorage.getItem(paginationFlag) === '1') completePaginationReset();
  });

  desktopMedia.addEventListener?.('change', placeSearchBar);
  document.addEventListener('DOMContentLoaded', initialiseSearchPlacement, { once: true });
  window.addEventListener('load', placeSearchBar, { once: true });
  document.addEventListener('shopify:section:load', initialiseSearchPlacement);
})();
